import { Avatar, Message } from '@chatscope/chat-ui-kit-react';
import { Button, IconButton, Stack, Step, StepLabel, Stepper, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { variants } from '../../../../variants/variants';
import { ArrowRightAltRounded, HistoryRounded, PreviewOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { selectMyPendingForm, setPreview } from '../../giftSlice';
import { toggleSwipe } from '../../../Search/searchSlice';

const stages = {
  Pending: 1,
  Manager_approved: 2,
  Meeting_scheduled: 3,
  HR_approved: 4,
  Admin_approved: 5,
};
const PendingGift = () => {
  const dispatch = useDispatch();
  const initialSteps = [
    { title: 'Application submitted', date: 'submissionDate' },
    { title: 'Approved by manager', date: 'managerApproveDate' },
    { title: 'Meeting scheduled by HR', date: 'updatedAt' },
    { title: 'Approved by HR', date: 'hrApproveDate' },
    { title: 'Approved by admin', date: 'adminApproveDate' },
  ];
  const [steps, setSteps] = useState(initialSteps);
  const pendingForm = useSelector(selectMyPendingForm);
  const handleViewForm = () => {
    dispatch(
      setPreview({
        response: pendingForm.response,
        currentDesignation: pendingForm.currentDesignation,
        desiredDesignation: pendingForm.desiredDesignation,
        ...(pendingForm?.status === 'Requires_changes' && { edit: true, reason: pendingForm?.remarks }),
      })
    );
    dispatch(toggleSwipe({value:true}))
  };

  useEffect(() => {
    if (pendingForm?.status === 'Requires_changes') {
      let temp = [...steps];
      temp.splice(1, 0, { title: 'Requires changes by manager', date: 'updatedAt' });
      setSteps(temp);
      Object.keys(stages).forEach((stage, index) => {
        if (index > 0) {
          stages[stage] = stages[stage] + 1;
        }
      });
      stages['Requires_changes'] = 2;
    }

    return () => {
      setSteps(initialSteps);
    };
  }, [pendingForm]);
  return (
    <Message
      className='incoming full-width'
      style={{ display: pendingForm ? 'block' : 'none' }}
      model={{
        direction: 'incoming',
        position: 'single',
      }}
    >
      <Avatar
        className='chatAvatar'
        name='Emily'
        src='https://chatscope.io/storybook/react/assets/emily-xzL8sDL2.svg'
      />
      <Message.CustomContent style={{ width: '100%' }}>
        <Stack direction={'rows'} alignItems={'center'}>
          <Typography sx={{ fontSize: variants.BODY, fontWeight: 700 }}>
            Your application details:
            <Button size='small' startIcon={<PreviewOutlined />} onClick={handleViewForm}>
              View form
            </Button>
          </Typography>
          {pendingForm?.juryMeetingDate && (
            <Stack direction={'rows'} alignItems={'center'} sx={{ ml: 'auto' }}>
              <HistoryRounded />
              <Typography sx={{ fontSize: variants.BODY, ml: 1 }}>
                Jury meeting at: {new Date(pendingForm?.juryMeetingDate).toDateString()}
              </Typography>
            </Stack>
          )}
        </Stack>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ width: '80%', m: 'auto' }}
          alignItems={'center'}
        >
          <Typography sx={{ fontSize: variants.BODY }}>{pendingForm?.currentDesignation}</Typography>
          <ArrowRightAltRounded fontSize='large' sx={{ color: '#0A4FAC' }} />
          <Typography sx={{ fontSize: variants.BODY }}>{pendingForm?.desiredDesignation}</Typography>
        </Stack>
        <Stepper alternativeLabel activeStep={stages[pendingForm?.status]} sx={{ mt: 2 }}>
          {steps.map((label, index) => {
            return (
              <Step key={index} completed={index < stages[pendingForm?.status]}>
                <StepLabel>
                  <Typography sx={{ fontSize: variants.BODY }}>{label.title}</Typography>
                  {index < stages[pendingForm?.status] && (
                    <Typography sx={{ fontSize: variants.TINY }}>
                      {new Date(pendingForm && pendingForm[label.date]).toDateString()}
                    </Typography>
                  )}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Message.CustomContent>
    </Message>
  );
};

export default PendingGift;
